import * as storybook from './storybook/platform';
import type { ImageLoaderConfig, PlatformClientEnv } from './types';
import * as vercel from './vercel/platform';

type ClientProvider = {
  imageLoader: ImageLoaderConfig;
  env: PlatformClientEnv;
};

// Static imports on a build-time literal: the bundler drops the providers this
// build doesn't select, and the selected one ships in the modulepreloaded
// graph. A dynamic import would hold up hydration, and every module reading
// `env`, for one more round trip after the initial JS has loaded.
function selectProvider(): ClientProvider {
  switch (__PLATFORM__) {
    case 'vercel':
      return vercel;
    case 'storybook':
      return storybook;
    default:
      throw new Error(`Unsupported PLATFORM: ${String(__PLATFORM__)}`);
  }
}

const provider = selectProvider();

export const imageLoader: ImageLoaderConfig = provider.imageLoader;
export const env: PlatformClientEnv = provider.env;
